import { PersonAccount } from "./person-account";
import { PurchaseOrderDetailModel, PurchaseOrderDetailTranslateModel } from "./po-detail";
import { PurchaseOrder } from "./purchase-order";
import { PurchaseReceipt } from "./purchase-receipt";
import { SystemField } from "./system-field"; 

export class PurchaseReceiptDetailModel extends SystemField { 
    purchase_receipts_id?:string;
    product_id?:string;
    receive_qty?:number;
    po_detail_id?:string;
    purchase_order_id?:string;
    warehouse_id?:string;
    location_id?:string;
    uom_id?:string;
    prev_receive_qty?:number;
    prev_open_qty?:number;
    discount_rate?:number;
    discount_amount?:number;
    orig_purchase_receipts_id?:string;
    accrual_coa_id?:string;
    inventory_coa_id?:string;

    open_qty?: number;
    return_qty?: number;
    old_qty?: number;
    return_id?:string;
    amount?:number;
    requere_pr_detail?:number;
     

     // block relationship 
    receipt?: PurchaseReceipt;
    order_details?: PurchaseOrderDetailModel;
    purchase_order_detail?: PurchaseOrderDetailTranslateModel;
    purchase_order?: PurchaseOrder;
    vendor?: PersonAccount;
}
